import React, { useEffect, useState } from 'react';
import { Container, Grid, TextField, Button, Snackbar, Typography } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import SaveIcon from '@mui/icons-material/Save'; // Importa el icono Save de Material-UI

import Navbar from '../Navbar';
import { useCode } from '../contexts/Code';
import { useParams, useHistory } from 'react-router-dom';
import { generateHash } from '../utils'

import { supabase } from '../supabaseClient'

import ReactCodeInput from 'react-code-input';


const inputStyle = {
  fontFamily: 'monospace',
  MozAppearance: 'textfield',
  borderRadius: '6px',
  border: '1px solid',
  boxShadow: '0px 0px 10px 0px rgba(0,0,0,.10)',
  margin: '4px',
  paddingLeft: '8px',
  paddingRight: 0,
  width: '45px',
  height: '60px',
  fontSize: '32px',
  boxSizing: 'border-box',
}

export default function Code() {
  const { updateCode, code } = useCode();
  const history = useHistory();

  const [inputCode, setInputCode] = useState('');
  
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleInputChange = (value) => {
    setInputCode(value);
  };

  const handleSaveCode = async () => {
    setInputCode('');

    var { data, error } = await supabase
      .from('companies')
      .select('*')

    var company = data.find(company => generateHash(company.name) == inputCode)

    if (!company) {
      setErrorMessage('Codigo incorrecto');
      setErrorOpen(true);
      return;
    }

    updateCode(company.id);

    if (company.simple_mode) {
      history.push('/sessions');
    } else {
      history.push('/login');
    }
      //history.push('/sessions'); // Redirecciona a la pantalla /sessions después de guardar el código
  };


  const handleCloseError = () => {
    setErrorOpen(false);
  };

  useEffect(() => {
    if (inputCode.length == 4) {
      handleSaveCode()
    }
  }, [inputCode])

  useEffect(()=>{
    const companyId = new URLSearchParams(window.location.search).get('company');

    if (companyId) {
      updateCode(companyId);
      history.push('/sessions');
    }
  },[])

  return (
    <>
      <Navbar title={'Enter Code'} />
      <Container component="main" sx={{ marginTop: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
        <img src="https://i.imgur.com/jb1r0JF.png" alt="Logo" style={{ height: '100px', width: 'auto', marginBottom: '20px' }} />
        <p style={{ color: '#4285F4', fontSize: '24px', textAlign: 'center' }}>Hello! Enter your company code</p>
        <ReactCodeInput
          onChange={handleInputChange}
          inputCode={inputCode}
          type='number'
          inputStyle={inputStyle}
          fields={4}
        />
      </Container>
    
      <Snackbar open={errorOpen} autoHideDuration={6000} onClose={handleCloseError}>
        <MuiAlert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Container component="main" sx={{ marginTop: 2, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
        <img src="https://i.imgur.com/jb1r0JF.png" alt="Logo" style={{ height: '100px', width: 'auto', marginBottom: '20px' }} />
        <p style={{ color: '#4285F4', fontSize: '24px', textAlign: 'center' }}>Hello! Enter your company code</p>
        <ReactCodeInput
          onChange={handleInputChange}
          inputCode={inputCode}
          type='number'
          inputStyle={inputStyle}
          fields={4}
        />
      </Container>
    </>
  );

}